import { Linkedin, Instagram, Mail } from "lucide-react";

export function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-foreground text-background relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 relative z-10">
        <div className="grid md:grid-cols-3 gap-6">
          <div>
            <span className="text-xl font-bold tracking-tight">FuzionLabs</span>
            <p className="mt-2 text-sm opacity-70">
              Pipeline systems and lead generation for immigration law firms.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2 text-xs uppercase tracking-wider opacity-60">Navigation</h4>
            <ul className="space-y-1 text-sm">
              <li><button onClick={() => scrollTo("services")} className="opacity-70 hover:opacity-100 transition-opacity">Services</button></li>
              <li><button onClick={() => scrollTo("how-it-works")} className="opacity-70 hover:opacity-100 transition-opacity">How It Works</button></li>
              <li><button onClick={() => scrollTo("results")} className="opacity-70 hover:opacity-100 transition-opacity">Results</button></li>
              <li><button onClick={() => scrollTo("cta")} className="opacity-70 hover:opacity-100 transition-opacity">Free Audit</button></li>
              <li><a href="/blog" className="opacity-70 hover:opacity-100 transition-opacity">Blog</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-2 text-xs uppercase tracking-wider opacity-60">Connect</h4>
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/fuzionlabs/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="opacity-70 hover:opacity-100 transition-opacity"><Linkedin className="w-5 h-5" /></a>
              <a href="#" aria-label="Instagram" className="opacity-70 hover:opacity-100 transition-opacity"><Instagram className="w-5 h-5" /></a>
              <a href="mailto:karstenbates@fuzionlabs.org" aria-label="Email" className="opacity-70 hover:opacity-100 transition-opacity"><Mail className="w-5 h-5" /></a>
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-background/10 text-center text-xs opacity-50 space-y-1">
          <p>© 2025 FuzionLabs. All rights reserved.</p>
          <p>
            FuzionLabs is an independent marketing services company. Results mentioned on this site reflect individual campaign outcomes and third-party case studies. Results will vary.
          </p>
        </div>
      </div>
    </footer>
  );
}
